import { render, staticRenderFns } from "./right_7.vue?vue&type=template&id=7ff88d71&scoped=true&"
import script from "./right_7.vue?vue&type=script&lang=js&"
export * from "./right_7.vue?vue&type=script&lang=js&"
import style0 from "./right_7.vue?vue&type=style&index=0&id=7ff88d71&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff88d71",
  null
  
)

export default component.exports